import Vue from 'vue'
import Router from 'vue-router'
import AppContent from '@/components/AppContent'
import AppInit from '@/components/AppInit'
import store from '@/components/store.js'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      component: AppInit
    },
    { path: '/card/:cardId',
      name: 'card',
      component: AppContent,
      props: function (route) { return { card: store.state.cards[route.params.cardId] } },
      beforeEnter: function (to, from, next) {
        next()
        // reload protection
        //        if (!(to.params.cardId in store.state.cards)) {
        //          next('/')
        //        } else {
        //          next()
        //        }
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js